module.exports = __webpack_public_path__ + "static/img/weatherroute1.3bb1297.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/product/weatherroute1.png
// module id = pHkq
// module chunks = 0